<template>
  <router-view></router-view>
</template>
<script>
// import {forbidSpaceEvent} from '@/utils/index'

export default{
  // mounted () {
  //   window.addEventListener('keydown', (e) => {
  //     forbidSpaceEvent(e)
  //   })
  // }
}
</script>
